/**
 * Client-side PostHog lifecycle plugin (`MAR-1236` / `MAR-1347` / `MAR-1348`).
 *
 * Evaluates jurisdiction consent on boot and on each route navigation (`router.afterEach`).
 */
import { useAnalyticsConsent } from '~/composables/useAnalyticsConsent'
import { usePostHog } from '~/composables/usePostHog'

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const router = useRouter()
  const { syncAnalyticsEngine } = useAnalyticsConsent()
  const { capturePageview } = usePostHog()

  // Initial evaluation on client boot
  const active = syncAnalyticsEngine()
  if (active) {
    capturePageview(router.currentRoute.value.fullPath)
  }

  let initialNavigationSkipped = false
  router.afterEach((to) => {
    if (!initialNavigationSkipped) {
      initialNavigationSkipped = true
      return
    }
    const nowActive = syncAnalyticsEngine()
    if (nowActive) {
      capturePageview(to.fullPath)
    }
  })
})
